import {
  PROVISIONAL_BILLING_MY_RECORDS_REQUEST,
  PROVISIONAL_BILLING_MY_RECORDS_SUCCESS,
  PROVISIONAL_BILLING_MY_RECORDS_FAIL,
  PROVISIONAL_BILLING_SUBMIT_REQUEST,
  PROVISIONAL_BILLING_SUBMIT_SUCCESS,
  PROVISIONAL_BILLING_SUBMIT_FAIL,
  PROVISIONAL_BILLING_SUBMIT_RESET,
  PROVISIONAL_BILLING_BULK_UPDATE_REQUEST,
  PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS,
  PROVISIONAL_BILLING_BULK_UPDATE_FAIL,
  PROVISIONAL_BILLING_BULK_UPDATE_RESET,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL,
  PROVISIONAL_BILLING_ALL_RECORDS_REQUEST,
  PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS,
  PROVISIONAL_BILLING_ALL_RECORDS_FAIL,
} from '../constants/provisionalBillingConstants';

export const provisionalBillingMyRecordsReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case PROVISIONAL_BILLING_MY_RECORDS_REQUEST:
      return { loading: true, records: [] };
    case PROVISIONAL_BILLING_MY_RECORDS_SUCCESS:
      return { loading: false, records: action.payload };
    case PROVISIONAL_BILLING_MY_RECORDS_FAIL:
      return { loading: false, error: action.payload, records: [] };
    default:
      return state;
  }
};

export const provisionalBillingSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case PROVISIONAL_BILLING_SUBMIT_REQUEST:
      return { loading: true };
    case PROVISIONAL_BILLING_SUBMIT_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case PROVISIONAL_BILLING_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case PROVISIONAL_BILLING_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

export const provisionalBillingBulkUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case PROVISIONAL_BILLING_BULK_UPDATE_REQUEST:
      return { loading: true };
    case PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case PROVISIONAL_BILLING_BULK_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PROVISIONAL_BILLING_BULK_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const provisionalBillingSupervisorBanksReducer = (state = { banks: [] }, action) => {
  switch (action.type) {
    case PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST:
      return { loading: true, banks: [] };
    case PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS:
      return { loading: false, banks: action.payload };
    case PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL:
      return { loading: false, error: action.payload, banks: [] };
    default:
      return state;
  }
};

export const provisionalBillingAllRecordsReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case PROVISIONAL_BILLING_ALL_RECORDS_REQUEST:
      return { loading: true, records: [] };
    case PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS:
      return { loading: false, records: action.payload };
    case PROVISIONAL_BILLING_ALL_RECORDS_FAIL:
      return { loading: false, error: action.payload, records: [] };
    default:
      return state;
  }
};
